import React from 'react';
import { IClientInfo } from '../../lib/types';
import { HomeLayout } from './HomeLayout';
import { DefaultHomeContent } from './DefaultHomeContent';

interface AuthenticatedHomePageProps {
  themeConfig: IClientInfo;
  translations: any;
}

export const AuthenticatedHomePage: React.FC<AuthenticatedHomePageProps> = ({
  themeConfig,
  translations
}) => {
  return (
    <HomeLayout
      themeConfig={themeConfig}
      translations={translations}>
      <DefaultHomeContent
        themeConfig={themeConfig}
        translations={translations}
      />
    </HomeLayout>
  );
};
